import { SET_TRANSLATIONS, REMOVE_TRANSLATIONS, REPLACE_TRANSLATIONS } from './types'
import { getPhrases } from '../../resources/translations'
import {polyglot} from '../../index'

const localeIndependent = {
  'localeIndependent': {
    'hepatitis_b': 'Hepatitis B',
    'hib': 'Hib',
    'diphtheria': 'Diphtheria',
    'tetanus': 'Tetanus',
    'pertussis': 'Pertussis',
    'poliomyelitis': 'Poliomyelitis',
    'pneumococcal_disease': 'Pneumococcal Disease',
    'meningococcal_infection': 'Meningoloccal Infection',
    'measles': 'Measles',
    'mumps': 'Mumps',
    'rubella': 'Rubella',
    'uterine_cancer': 'Uterine Cancer',
    'varicella': 'Varicella',
    'influenza': 'Influenza',
    'rotavirus': 'Rotavirus',
    'tuberculosis': 'Tuberculosis',
    'japanese_encephalitis': 'Japanese Encephalitis',
    'cholera': 'Cholera',
    'yellow_fever': 'Yellow Fever',
    'typhoid_fever': 'Typhoid Fever',
    'hepatitis_a': 'Hepatitis A',
    'rabies': 'Rabies'
  }
}

export function setTranslations (locale) {
  const phrases = getPhrases(locale)
  polyglot.locale(locale)
  polyglot.replace(phrases)
  polyglot.extend(localeIndependent)
  return {
    type: SET_TRANSLATIONS,
    payload: {
      locale,
      phrases
    }
  }
}

export function removeTranslations () {
  polyglot.clear()
  return {
    type: REMOVE_TRANSLATIONS
  }
}

export function replaceTranslations (locale) {
  const phrases = getPhrases(locale)
  polyglot.locale(locale)
  polyglot.replace(phrases)
  polyglot.extend(localeIndependent)
  return {
    type: REPLACE_TRANSLATIONS,
    payload: {
      locale,
      phrases
    }
  }
}
